export default __webpack_public_path__ + "static/media/cards-icon.90ce4ec7.svg";